import { CoachingHub } from '../components/CoachingHub';

export function CoachPage() {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <CoachingHub />
    </div>
  );
}
